import moment from 'moment';

function pluralizeText(unit, time) {
  return time && time > 1 ? unit + 's' : unit;
}

export function secondsToTextFormat(seconds){
  var duration = moment.duration(seconds, 'seconds'),
    secs = duration.seconds(),
    mins = duration.minutes(),
    hours = duration.hours(),
    days = duration.days(),
    text = '';

  text += (days ? days + ' ' + pluralizeText('day', days) + ' ' : '');
  text += (hours ? hours + ' ' + pluralizeText('hour', hours) + ' ' : '');
  text += (mins ? mins + ' ' + pluralizeText('min', mins) + ' ' : '');
  text += (secs ? secs + ' ' + pluralizeText('sec', secs) + ' ' : '');
  return text;
}
